module.exports = "./img/f5e49088ae47adf618094d152e762b39.jpg";